import { Referral } from '@/types'
import { useState, useEffect } from 'react'

export default function useAppBannerForIosSafari(
  referral: Referral,
  clientGUID: string
) {
  const [userAgent, setUserAgent] = useState('')

  useEffect(() => {
    const { userAgent: UA } = navigator
    setUserAgent(UA)
  }, [])

  const isIphone = userAgent.match(/iPhone/i)
  const webkit = !!userAgent.match(/WebKit/i)
  const iOSSafari = isIphone && webkit && !userAgent.match(/CriOS/i)

  const impressionUrl = [
    'https://imp.control.kochava.com/track/impression?campaign_id=koiospriceline388053593d51c5580c1da575ac62c7&network_id=1017',
    `&PAGEID=IOS_SMARTBANNER`,
    `&REFID=${referral?.sourceId ?? ''}${referral?.id ?? ''}`,
    `&REFCLICKID=${referral?.clickId ?? ''}`,
    `&SUB_SITE_ID=${clientGUID}&site_id=1`
  ].join('')

  return [iOSSafari, impressionUrl]
}
